__webpack_require__.p = "/oasis-uniandes/";